import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import App from './components/app/App'
import registerServiceWorker from './registerServiceWorker';
import store from 'store';
import { Provider, ReactReduxContext } from 'react-redux';
import { history } from 'store/root-reducer'; 

// Get the application-wide store instance, prepopulating with state from the server where available.
// const store = configureStore(history);

ReactDOM.render(
    <Provider store={store} context={ReactReduxContext}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

//registerServiceWorker();

// ALAN-TODO: fix console warnings (defined but never used)